import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "form-group mt-2" }
const _hoisted_4 = {
  key: 0,
  class: "form-group mt-2"
}
const _hoisted_5 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_address = _resolveComponent("op-address")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Configurazione orari",
        text: "Configurazione orari"
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-warning",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModalOrari && _ctx.openModalOrari(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Orari della settimana",
          text: "Orari della settimana"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "ml-2 btn btn-warning",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openInclusioneOrari && _ctx.openInclusioneOrari(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Includi giorni",
          text: "Includi giorni"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "ml-2 btn btn-warning",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openEsclusioneOrari && _ctx.openEsclusioneOrari(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Escludi giorni",
          text: "Escludi giorni"
        })
      ]),
      _hoisted_2,
      (_ctx.config)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Appuntamento in video call",
                  text: "Appuntamento in video call"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.isVideoCall) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.config.isVideoCall]
              ])
            ]),
            (!_ctx.config.isVideoCall)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("label", null, [
                    _createElementVNode("b", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Indirizzo per gli appuntamenti",
                        text: "Indirizzo per gli appuntamenti"
                      })
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-warning ml-2",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyShippingAddress && _ctx.copyShippingAddress(...args)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Copia da indirizzo di spedizione",
                      text: "Copia da indirizzo di spedizione"
                    })
                  ]),
                  _createVNode(_component_op_address, {
                    modelValue: _ctx.config.address,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.address) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Salva",
                  text: "Salva"
                })
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}